import {
  SoftwareManagementCreateCustomSoftwareDocument,
  SoftwareManagementCreateCustomSoftwareMutation,
  SoftwareManagementCreateCustomSoftwareMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCustomSoftware = () => {
  const [createCustomSoftware, { loading }] = useMutation(
    SoftwareManagementCreateCustomSoftwareDocument,
    {
      extractorFn: (data: SoftwareManagementCreateCustomSoftwareMutation) =>
        data.softwareManagementMutations.createSoftwaremanagementCustomSoftware,
    }
  )

  return {
    createCustomSoftware(variables: SoftwareManagementCreateCustomSoftwareMutationVariables) {
      return createCustomSoftware({
        variables,
      })
    },
    loading,
  }
}
